import { React, useState, useEffect, useRef } from "react";
import { Header } from "../../../components/common/Header.js";
import { useParams } from "react-router-dom";
//Child Comp
import { InfoShowcase } from "../../../features/MovieShowcase/InfoShowcase.js";
import { SocialBar } from "../../../features/SocialBar/SocialBar.js";
import { WatchShowcase } from "../../../features/MovieShowcase/WatchShowcase.js";
import { MediaShowcase } from "../../../features/MovieShowcase/MediaShowcase.js";
import { MovieTagCarousel } from "../../../features/MovieTag/MovieTagCarousel.js";
import { CollectionShowCase } from "../../../features/MovieShowcase/CollectionShowcase.js";
import { SideBar } from "../../../features/SideBar/SideBar.js";
//Import API Test below
import { get_detail } from "../../../api/getMovie.js";
import { extractMovData } from "../../../utility/utility.js";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { getDetail } from "../DetailSlice.js";
import { toggleListLoading } from "../DetailSlice.js";
//Utility
import { extractDetailData } from "../../../utility/utility.js";
//Style
import "../DetailsPage.css"; 

export const MovieDetailPage = () => {
  const sampleId = 531428;
  const { movieId } = useParams();

  let [detailData, setDetailData] = useState(null);

  //Get Config
  let apiUtility = useSelector((state) => state.apiUtility.apiUtility);
  let { langConfig, movGenreList } = apiUtility;

  //Handle API Call
  const dispatch = useDispatch();
  let detailDataList = useSelector((state) => state.detail);

  useEffect(() => {
    if (!detailDataList.detailList["movList"][movieId]) {
      if (detailData) {
        setDetailData(null); //MidAutumn
      }
      dispatch(getDetail({ id: movieId, type: "mov" })).then(res => {
        setDetailData(res.payload)
      });
    }else{
      setDetailData(detailDataList.detailList.movList[movieId])
    }
  }, [movieId]);

  if (detailDataList.detailListLoading || !detailData){
    return <div className="loading_site"><h3>Loading details ...</h3></div>
  }else if (detailDataList.detailListError){
    return <h3>Error 404</h3>
  }

  return (
    <>
      <div className="movie-detail-page">
        <Header />

        <div className="mov_details_page_content_wrapper">
          <InfoShowcase
            detailData={detailData}
            langConfig={langConfig}
            genreList={movGenreList}
          />
          <WatchShowcase detailData={detailData} />
          <MediaShowcase detailData={detailData} />
          <CollectionShowCase
            detailData={detailData["belongs_to_collection"]}
          />
          <div className="mov_details_page recommendation_carousel">
            <div className="recommendation_carousel carousel_title">
              Recommendations
            </div>
            <MovieTagCarousel
              movieItems={detailData["recommendation"]}
              isHoverEnable={true}
              isGrid={true}
              isDefaultSmall={true}
              movieType="mov"
            />
          </div>
        </div>
      </div>
      <SideBar />
    </>
  );
};
